import React, { useState, useEffect } from "react";
import MobileNavbar from "./MobileNavbar";
import CollectionsLinkTabs from "./Collections/CollectionsLinkTabs";
import styles from "./index.module.css";
import PostsSection from "./PostsSection";
import Collections from "./Collections";
import { useDispatch, useSelector } from "react-redux";
import LinksInBio from "./LinksInBio";
import previewIcon from "../../assets/icons/previewIcon.png";
import loadingGif from "../../assets/icons/mobileIcons/loader.gif";
import closeIcon from "../../assets/dashboard/popup-close.png";
import BottomNav from "../Builder/RightContainer/Preview/BottomNav";
import Store from "../Builder/RightContainer/Preview/Store";
import LinkInBio from "../Builder/RightContainer/Preview/LinkInBio";
import ProductPage from "../Builder/RightContainer/Preview/Store/CollectionPage";
import { publishFaymWall } from "../../Services/apiServices/publishService";
import ProductsScreen from "./Collections/ProductsScreen";
import LinksScreen from "./LinksInBio/LinksScreen";
import DeleteSectionPopup from "./DeleteSectionPopup";
import {
    closePublishSuccessModal,
    closeSectionDeleteModal,
    setDescriptionEditing,
    setInstaAuthModalClose,
    setIsPreviewCollectionOpened,
    setLinksDiff,
    setMagicButtonState,
    setMagicLinkInput,
    setPluginSelected,
    setPublishButtonEnabled,
    setSectionsDiff,
    setSelectedCollection,
    setSelectedHeader,
    setSelectedLinkInBio,
    setSelectedScreen,
    setSelectedSection,
    updateProfileData
} from "../../redux/slice/dashboardSlice";
import { getUserData } from "../../Services/apiServices/userService";
import { getBrandsIcons, getCollectionsData, getLinkInBioData, getPostsData } from "../../Services/apiServices/dashboardService";
import { getThemesData } from "../../Services/apiServices/themesService";
import Modal from "./../CommonV2/Modal";
import Loader from "./../CommonV2/MobileLoader";
import { message } from "antd";
import { getPlugins } from "../../Services/apiServices/pluginsService";

const index = () => {
    const [isPreviewOpened, setIsPreviewOpened] = useState(false);
    const [isSectionChanged, setIsSectionChanged] = useState(false);
    const dispatch = useDispatch();
    const {
        selectedHeader,
        selectedCollection,
        selectedLinkInBio,
        selectedScreen,
        storeSectionsChanged,
        isSectionPickModalOpen,
        magicLinkResponse,
        isSectionDeleteModalOpen,
        isSectionCreateModalOpen,
        publishButtonEnabled,
        isPublishedSuccessModalOpen,
        publishLoading,
        isSectionDeleting,
        isPreviewCollectionOpened
    } = useSelector((state) => state.root.dashboard);

    const { user } = useSelector((state) => state.root.auth);
    const [isLoading, setIsLoading] = useState(true);
    const [isMainContainerScrolling, setIsMainContainerScrolling] = useState(false);

    function fallbackCopyTextToClipboard(text) {
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand("copy");
            message.success("Faym Wall Link Copied");
        } catch (err) {
            message.error("Failed to copy the link");
        }
        document.body.removeChild(textArea);
    }

    const getFaymData = async () => {
        setIsLoading(true);
        await getUserData();
        await getLinkInBioData();
        await getCollectionsData();
        await getPostsData(true);
        await getPostsData(false);
        await getBrandsIcons();
        setIsLoading(false);
    };
    useEffect(() => {
        getFaymData();
        getThemesData();
        getPlugins();
        dispatch(setSelectedHeader("Collections"));
        dispatch(setMagicButtonState("INITIAL"));
        dispatch(setMagicLinkInput(""));
        dispatch(setPublishButtonEnabled(null));
        dispatch(setLinksDiff(null));
        dispatch(setSectionsDiff(null));
        dispatch(updateProfileData(null));
        dispatch(setInstaAuthModalClose());
        dispatch(closePublishSuccessModal());
        dispatch(setSelectedCollection(null));
        dispatch(setSelectedLinkInBio(null));
        dispatch(setSelectedScreen(null));
        dispatch(setIsPreviewCollectionOpened(false));
    }, []);

    const openPreview = () => {
        setIsPreviewOpened(true);
    };

    const closePreview = () => {
        setIsPreviewOpened(false);
        dispatch(setIsPreviewCollectionOpened(false));
    };

    const publishChanges = async () => {
        await publishFaymWall();
        message.success("Faym Wall Published Successfully!");
    };

    useEffect(() => {
        const hideImagePopup = (e) => {
            if (e.target.tagName === "IMG") {
                e.preventDefault();
            }
        };
        document.addEventListener("contextmenu", hideImagePopup);

        return () => {
            document.removeEventListener("contextmenu", hideImagePopup);
        };
    }, []);
    return isLoading ? (
        <div>
            <Loader />
        </div>
    ) : (
        <div
            onClick={() => {
                dispatch(setSelectedSection(null));
                dispatch(setPluginSelected(null));
                dispatch(setDescriptionEditing(null));
            }}
        >
            <div className={styles.mobileBuilder}>
                <div className={styles.headerContainer}>
                    <MobileNavbar />
                    {!selectedScreen && selectedHeader !== "LinkInBio" ? <CollectionsLinkTabs /> : <></>}
                </div>
                <div className={styles.mainContainer}>
                    {selectedScreen === "collection" ? (
                        <ProductsScreen />
                    ) : selectedScreen === "linkinbio" ? (
                        <LinksScreen />
                    ) : (
                        <>
                            {selectedHeader === "Posts" ? (
                                <PostsSection />
                            ) : selectedHeader === "Collections" ? (
                                <Collections />
                            ) : selectedHeader === "LinkInBio" ? (
                                <LinksInBio />
                            ) : (
                                <></>
                            )}
                        </>
                    )}
                </div>

                <div className={styles.floatingContainer} onClick={publishButtonEnabled ? publishChanges : openPreview}>
                    {publishButtonEnabled && (
                        <>
                            <img
                                className={styles.previewImg}
                                src={previewIcon}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openPreview();
                                }}
                            />
                            <span className={styles.divider}></span>
                        </>
                    )}
                    <span className={styles.floatingText}>{publishButtonEnabled ? "Publish" : "Preview"}</span>
                </div>
                {isPreviewOpened && (
                    <div className={styles.fixedOverlay} onClick={closePreview}>
                        <img src={closeIcon} className={styles.closePreview} onClick={openPreview} />
                        <div
                            className={styles.previewContainer}
                            style={isPreviewCollectionOpened ? { height: "100%" } : { height: "calc(100% - 100px)" }}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <div style={{ height: "100%" }}>
                                {selectedCollection && isPreviewCollectionOpened ? (
                                    <ProductPage />
                                ) : selectedHeader === "Posts" || selectedHeader === "Collections" ? (
                                    <Store />
                                ) : (
                                    <LinkInBio />
                                )}
                                {!selectedCollection && <BottomNav />}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {(publishLoading || isSectionDeleting) && (
                <div className={styles.loadingOverlay}>
                    <img src={loadingGif} className={styles.loader} />
                </div>
            )}

            {isSectionDeleteModalOpen && (
                <DeleteSectionPopup section={selectedHeader === "Collections" ? selectedCollection : selectedLinkInBio} />
            )}
        </div>
    );
};

export default index;
